import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Tab,
  Box,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { BiMinusCircle } from "react-icons/bi";
import { useMutation, useQuery } from "@apollo/client";
import ViewReqTakeOut from "./ViewTakeOut/ViewReqTakeOut";
import ViewDelivery from "./ViewTakeOut/ViewDelivery";
import ViewRecieve from "./ViewTakeOut/ViewRecieve";
import ViewApproveTakeOut from "./ViewTakeOut/ViewApproveTakeOut";

//src

import "../../Style/dialogstyle.scss";

export default function ViewTakeOut({
  open,
  editData,
  handleClose,
  setRefetch,
  dialogTitle,
}) {

  //tab
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">ពិនិត្យទទួល</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container rowSpacing={2} columnSpacing={3}>
          <Grid item xs={12}>
            <Typography className="dialog-title-view">សម្ភារៈ</Typography>
          </Grid>
          <Grid item xs={12}>
            <Stack direction="row" spacing={2}>
              <Stack direction="column" spacing={2}>
                <Typography className="field-title">អ្នកតំណាងការិយាល័យ</Typography>
                <Typography className="field-title">ឃ្លាំងទំនិញ</Typography>
              </Stack>
              <Stack direction="column" spacing={2}>
                <Typography className="field-title">:</Typography>
                <Typography className="field-title">:</Typography>
              </Stack>
              <Stack direction="column" spacing={2}>
                <Typography className="body-cell">
                  {editData?.userId?.mainUserId?.firstName + ' ' +editData?.userId?.mainUserId?.lastName + " (" + editData?.userId?.officeId?.officeKhName+')'}
                </Typography>
                <Typography className="body-cell">
                  {editData?.warehouseId?.warehouseName}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <TabContext value={value}>
              <Box sx={{ borderColor: "divider" }}>
                {editData?.status !== "Rejected" ? (
                  <TabList onChange={handleChange}>
                    <Tab label="សំណើរប្រើប្រាស់" value="1" />
                    <Tab label="ពិនិត្យអនុម័ត" value="2" />
                    <Tab label="ការបញ្ជាទិញ" value="3" />
                    <Tab label="ការទទួល" value="4" />
                  </TabList>
                ) : (
                  <TabList onChange={handleChange}>
                    <Tab label="សំណើរប្រើប្រាស់" value="1" />
                  </TabList>
                )}
             
              </Box>
              <TabPanel value="1">
                <ViewReqTakeOut editData={editData} />
              </TabPanel>
              <TabPanel value="2">
                <ViewApproveTakeOut editData={editData} />
              </TabPanel>
              <TabPanel value="3">
                <ViewDelivery editData={editData} />
              </TabPanel>
              <TabPanel value="4">
                <ViewRecieve editData={editData} />
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
